module.exports = __webpack_public_path__ + "img/a89946a8cd6634dd17b4162bce63239f.a89946a8.png";